<template>
  <v-layout style="backgroundColor: white">
    <v-flex>
      <v-toolbar dark class="secondary">
        <v-toolbar-title>Vendor Search</v-toolbar-title>
      </v-toolbar>
      <v-flex xs12 pl-3 pr-3>
        <v-autocomplete autofocus pl-3 pr-3 @input="applyVendor" prepend-icon="search" v-model="selectedVendor" :items="vendorList" label="Search Vendors" return-object item-text="name" item-value="name">
          <v-icon dark>people</v-icon>
          <template slot="selection" slot-scope="data">
              {{ !taskTemplate ? data.item : data.item.name }}
          </template>
          <template slot="item" slot-scope="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <v-icon style="margin-right:10px">{{data.item.type === 'Project' ? 'ballot' : data.item.type === 'Lead' ? 'person_outline' : 'person'}}</v-icon>
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.vendor_type.toString()"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
        <v-layout>
          <v-flex text-xs-right pb-2>
            <v-btn @click="closeDialog" color="secondary">Close</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash'
export default {
  props: ['taskTemplate', 'project', 'task', 'isTemplateCreation'],
  data () {
    return {
      selectedVendor: null
    }
  },
  mounted () {
    this.getVendorList()
  },
  computed: {
    vendorList () {
      // Get Vendor List
      const getVendors = this.$store.getters.vendorList
      // Format Drop Down with Groups
      // Get Distinct Groupings
      let groupList = []
      getVendors.forEach(vendor => {
        vendor.vendor_type.forEach(type => {
          groupList.push(type)
        })
      })
      groupList = [ ...new Set(groupList) ]
      // Iterate Groups To Organize Data
      let groups = []
      groupList.forEach(group => {
        getVendors.forEach(vendor => {
          vendor.vendor_type.forEach(vendorType => {
            if (vendorType === group) {
              groups.push({name: vendor.company_name + ' (' + group + ')', vendor_type: vendor.vendor_type, id: vendor.id, group: group})
            }
          })
        })
      })
      let groupItems = []
      groupList.forEach(group => {
        groupItems.push({header: group})
        const newItems = _.filter(groups, {group: group})
        newItems.forEach(item => {
          groupItems.push(item)
        })
      })
      return groupItems
    }
  },
  methods: {
    emittedVendor () {
      const payload = {name: this.selectedVendor.name, id: this.selectedVendor.id, taskId: this.task ? this.task.id : null}
      if (this.taskTemplate) {
        payload.task = this.task
      }
      this.$emit('emittedVendor', payload)
    },
    applyVendor () {
      if (!this.taskTemplate) {
        const payload = { project: this.project, task: this.task, vendor: this.selectedVendor }
        if (!this.isTemplateCreation) {
          this.$store.dispatch('addVendorToTask', payload)
        }
      }
      this.emittedVendor()
      this.closeDialog()
    },
    getVendorList () {
      if (!this.vendorList) {
        this.$store.dispatch('getVendorList')
      }
    },
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vendors/VendorSearch.vue